import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { Zap, Mail, ArrowLeft, Loader2, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_video-forge-417/artifacts/8amlg66h_Logo%20futuriste%20de%20ViralSynth.com.png";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success('Email envoye !');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-12">
          <img src={LOGO_URL} alt="ViralSynth" className="w-64 h-auto" />
        </Link>

        <div className="card-surface rounded-lg p-8 md:p-10">
          {sent ? (
            <div className="text-center" data-testid="forgot-password-sent">
              <CheckCircle className="w-12 h-12 text-[#34C759] mx-auto mb-4" />
              <h1 className="font-heading text-2xl font-medium text-white mb-2">Email envoye !</h1>
              <p className="text-sm text-white/40 mb-6">
                Si un compte existe avec l'adresse <strong className="text-white/60">{email}</strong>, 
                vous recevrez un lien de reinitialisation dans quelques instants.
              </p>
              <p className="text-xs text-white/30 mb-6">Verifiez egalement vos spams.</p>
              <Link to="/login" className="btn-outline text-sm inline-flex items-center gap-2">
                <ArrowLeft className="w-4 h-4" /> Retour a la connexion
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-medium text-white mb-2 text-center">
                Mot de passe oublie ?
              </h1>
              <p className="text-sm text-white/40 text-center mb-8">
                Entrez votre email et nous vous enverrons un lien de reinitialisation.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-xs text-white/50 mb-2">Email</label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full pl-10 pr-4 py-3 input-dark rounded-md text-sm"
                      placeholder="vous@email.com"
                      required
                      data-testid="forgot-email-input"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full btn-accent py-3 text-sm font-medium flex items-center justify-center gap-2 disabled:opacity-50"
                  data-testid="forgot-submit-btn"
                >
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Envoyer le lien'}
                </button>
              </form>

              <div className="mt-6 text-center">
                <Link to="/login" className="text-sm text-white/40 hover:text-white transition-colors inline-flex items-center gap-1">
                  <ArrowLeft className="w-3 h-3" /> Retour a la connexion
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
